import { Folder, FileText, Image, Trash, Copy, Scissors, Clipboard, Monitor, Palette, RefreshCw } from "lucide-react";
import { ContextMenu } from "../../ContextMenu";
import { useContextMenu } from "../../ContextMenu/useContextMenu";
import type { MenuItem } from "../../ContextMenu/types";

const desktopMenuItems: MenuItem[] = [
    {
        id: "view",
        label: "View",
        icon: <Monitor className="w-4 h-4" />,
        submenu: [
            { id: "large", label: "Large icons" },
            { id: "medium", label: "Medium icons" },
            { id: "small", label: "Small icons" },
            { id: "sep1", separator: true, label: "" },
            { id: "auto", label: "Auto arrange icons" },
            { id: "align", label: "Align icons to grid" },
        ],
    },
    {
        id: "sort",
        label: "Sort by",
        icon: <RefreshCw className="w-4 h-4" />,
        submenu: [
            { id: "name", label: "Name" },
            { id: "size", label: "Size" },
            { id: "type", label: "Type" },
            { id: "date", label: "Date modified" },
        ],
    },
    { id: "refresh", label: "Refresh", icon: <RefreshCw className="w-4 h-4" /> },
    { id: "sep1", separator: true, label: "" },
    {
        id: "new",
        label: "New",
        submenu: [
            { id: "folder", label: "Folder", icon: <Folder className="w-4 h-4" /> },
            { id: "text", label: "Text Document", icon: <FileText className="w-4 h-4" /> },
            { id: "image", label: "Image", icon: <Image className="w-4 h-4" /> },
        ],
    },
    { id: "sep2", separator: true, label: "" },
    { id: "display", label: "Display settings", icon: <Monitor className="w-4 h-4" /> },
    { id: "personalize", label: "Personalize", icon: <Palette className="w-4 h-4" /> },
    { id: "sep3", separator: true, label: "" },
    { id: "cut", label: "Cut", icon: <Scissors className="w-4 h-4" />, shortcut: "Ctrl+X" },
    { id: "copy", label: "Copy", icon: <Copy className="w-4 h-4" />, shortcut: "Ctrl+C" },
    { id: "paste", label: "Paste", icon: <Clipboard className="w-4 h-4" />, shortcut: "Ctrl+V" },
    { id: "delete", label: "Delete", icon: <Trash className="w-4 h-4" />, shortcut: "Del" },
];

export const DesktopContextMenu = () => {
    const { show, position, handleContextMenu, hideContextMenu } = useContextMenu();

    return (
        <div className="h-full w-full" onContextMenu={handleContextMenu}>
            {show && <ContextMenu items={desktopMenuItems} position={position} onClose={hideContextMenu} />}
        </div>
    );
};
